﻿//main.js
import * as bootstrap from 'bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../css/site.css';
import '../css/bookerMediaQueries.css';


import { initIsCreditSwitch, initTogglePassword } from './modules/ui.js';
import { initUpsertDatepicker, initPdfDateRangePickers } from './modules/datepicker.js';
import { init as initAccountEvents } from './modules/accountEvent.js';
import { init as initExportPdfActivities } from './modules/exportPdfActivities.js';


document.addEventListener('DOMContentLoaded', function () {

    //Initialisation des dropdowns bootstrap
    document.querySelectorAll('[data-bs-toggle="dropdown"]').forEach(el => {
        new bootstrap.Dropdown(el);
    });

    initTogglePassword();
    initUpsertDatepicker();
    initPdfDateRangePickers();
    initAccountEvents();
    initIsCreditSwitch();
    initExportPdfActivities();
})

